"use strict";
const angular = require("angular");
module.exports = angular.module("ssn.controllers", []);



// WEBPACK FOOTER //
// ./js/controllers/controllerModule.js